<template>
  <div>
    <Modal
      v-model="modalDialog"
      :closable="false"
      :mask-closable="false"
      :title="title"
      width="60%"
    >
      <table class="TB_COLLAPSE" width="100%">
        <thead>
          <tr>
            <th colspan="15">{{ title }}期数</th>
          </tr>
        </thead>
        <tbody>
          <tr class="tc">
            <th width="10%">期数</th>
            <td width="20%">
              <Input
                v-model="period"
                style="width: 150px"
                :disabled="disabled"
              />
            </td>
            <th width="10%">日期</th>
            <td width="20%">
              <DatePicker
                type="date"
                format="yyyy/MM/dd"
                placeholder="选择一个日期"
                style="width: 200px"
                v-model="todate"
                :disabled="disabled"
                @on-change="(event) => (todate = event)"
              ></DatePicker>
            </td>
            <th width="10%">状态</th>
            <td width="20%">
              <Select v-model="selectstate" style="width: 150px">
                <Option
                  v-for="item in selectdata"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.label }}</Option
                >
              </Select>
            </td>
          </tr>
          <tr>
            <th width="10%">开盘时间</th>
            <td width="20%">
              <TimePicker
                v-model="opdate"
                format="HH:mm:ss"
                placeholder="Select time"
                style="width: 120px"
              ></TimePicker>
            </td>
            <th width="10%">非特码停押时间</th>
            <td width="20%">
              <TimePicker
                v-model="stdate"
                format="HH:mm:ss"
                placeholder="Select time"
                style="width: 120px"
              ></TimePicker>
            </td>
            <th width="10%">关盘时间</th>
            <td width="20%">
              <TimePicker
                v-model="cldate"
                format="HH:mm:ss"
                placeholder="Select time"
                style="width: 120px"
              ></TimePicker>
            </td>
          </tr>
        </tbody>
      </table>
      <div slot="footer">
        <Button
          type="primary"
          size="large"
          @click="$emit('update:modal', false)"
          >取消</Button
        >
        <Button
          type="error"
          size="large"
          @click="checkfun()"
          :loading="loading"
          >{{ title }}</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";
import moment from "moment-timezone";
import { log } from "util";
export default {
  name: 'PeriodManagementSetting',
  props: {
    modal: {
      type: Boolean
    },
    stateModal: {
      // state: { 1: 新增, 2: 修改 }
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      modifyStatus: false,
      timedata: [],
      opdate: '00:00:00',
      stdate: '00:00:00',
      cldate: '00:00:00',
      period: "",
      todate: "",
      defaultselectstate: null,
      selectstate: 2,
      selectdata: [
        { value: 2, label: "等待开盘" },
        { value: 1, label: "开盘" },
        { value: 3, label: "非特码停押" },
        { value: 0, label: "关盘" }
      ]
    };
  },
  computed: {
    ...mapGetters(["getmember", "getgameid"]),
    nowdate () {
      return moment().tz("Asia/Taipei").valueOf()
    },
    modalDialog: {
      get () {
        return this.modal && this.modifyStatus;
      },
      set (val) {
        this.modifyStatus = false
        this.$emit("update:modal", val);
      }
    },
    title () {
      return this.stateModal.state === '1' ? "新增" : "修改";
    },
    disabled () {
      return this.stateModal.state === '2'
    }
  },
  watch: {
    modal (val) {
      if (val) {
        if (this.stateModal.state === "1") {
          this.getNewPeriodDate();
          this.selectstate = 2
        } else {
          this.getPeriodDate()
        }
      }
    }
  },
  methods: {
    async getNewPeriodDate () {
      try {
        const res = await this.$axios.periodManagement.NowAddPeriodData(this.getgameid)
        if ('status' in res && res.status === 0) return
        this.modifyStatus = true
        this.settingDate(res)
      } catch (error) {
        console.error(error)
        this.$Message.error('网路异常')
        this.modalDialog = false
      }
    },
    async getPeriodDate () {
      try {
        const res = await this.$axios.periodManagement.getPeriodDate(this.getgameid, this.stateModal.listid)
        if ('status' in res && res.status === 0) return
        this.modifyStatus = true
        this.settingDate(res)
      } catch (error) {
        console.error(err);
        this.$Message.error('网路异常')
        this.modalDialog = false
      }
    },
    settingDate (res) {
      const state = this.stateModal.state
      this.opdate = state === '1' ? res[0].time1 : res[0].opdate
      this.stdate = state === '1' ? res[0].time2 : res[0].stdate
      this.cldate = state === '1' ? res[0].time3 : res[0].cldate
      this.timedata = res[0]
      this.period = res[0].period
      this.todate = state === '1' ? res[0].todate.replace(/[\-]/g, "/") : res[0].date.replace(/[\-]/g, "/")
      if (state === '2') {
        this.selectstate = res[0].state
        this.defaultselectstate = res[0].state
      }
    },
    checkfun () {
      // 等待开盘 < 开盘 < 非特码关盘 < 关盘
      // 非特码关盘 关盘 有时是一样的
      // 开盘时间 <= 非特时间 <= 关盘时间
      // 状态 : 等待开盘  -> 开盘时间>目前时间
      // 状态 : 开盘  -> 非特码停押时间 > 目前时间
      // 状态 : 非特停  -> 关盘时间 > 目前时间
      // 状态 : 关盘  -> 免判断
      // this.selectstate 等待开盘2 开盘1 非特码停押3 关盘0
      const todate = moment(this.todate).format('YYYY-MM-DD') //现在时间
      const openTime = new Date(`${todate} ${this.opdate}`).getTime(); //开盘时间
      const stopBetTime = new Date(`${todate} ${this.stdate}`).getTime(); //非特码停压
      const closeTime = new Date(`${todate} ${this.cldate}`).getTime(); //关盘
      let basicFn = () => {
        if (openTime <= stopBetTime) {
          if (stopBetTime <= closeTime) {
            this.stateModal.state === "1" ? this.addPeriod() : this.modifyPeriod()
          } else {
            this.$Message.error({ duration: 3, content: "关盘时间须大于或是等于非特码停押时间" });
          }
        } else {
          this.$Message.error({ duration: 3, content: "非特码停押时间须大于或是等于等待开盘时间" });
        }
      }
      if (this.selectstate == 0) basicFn()
      if (this.selectstate == 1) {
        if (this.nowdate < stopBetTime) {
          basicFn()
        } else {
          this.$Message.error({ duration: 3, content: "非特码停押时间须大于目前时间" });
        }
      }
      if (this.selectstate == 2) {
        if (this.nowdate < openTime) {
          basicFn()
        } else {
          this.$Message.error({ duration: 3, content: "开盘时间须大于目前时间" });
        }
      }
      if (this.selectstate == 3) {
        if (this.nowdate < closeTime) {
          basicFn()
        } else {
          this.$Message.error({ duration: 3, content: "关盘时间须大于目前时间" });
        }
      }
    },
    async addPeriod () {
      this.loading = true
      const data = {
        loid: this.getmember.pid,
        period: this.period,
        perdate: moment(this.todate).format('YYYY-MM-DD'),
        opdate: this.opdate,
        stdate: this.stdate,
        cldate: this.cldate,
        state: this.selectstate
      }
      try {
        const res = await this.$axios.periodManagement.addPeriodDate(this.getgameid, data)
        if (res.status != '1') return this.$Message.error('新增失败')
        this.$Message.success('已新增');
        this.$emit("update:modal", false);
        this.$emit("resetList")
      } catch (error) {
        console.error(error);
        this.$Message.error('请填写正确资料')
      } finally {
        this.loading = false
      }
    },
    async modifyPeriod () {
      this.loading = true
      try {
        let find = this.selectdata.find(it => it.value == this.defaultselectstate)
        if (!find) return this.$Message.error('资料不正确')
        const oldstate = find.label
        const data = {
          loid: this.getmember.pid,
          oldstatetr: this.defaultselectstate,
          oldstate: oldstate,
          pid: this.stateModal.listid,
          period: this.period,
          perdate: moment(this.todate).format('YYYY-MM-DD'),
          opdate: this.opdate,
          stdate: this.stdate,
          cldate: this.cldate,
          state: this.selectstate
        }
        const res = await this.$axios.periodManagement.modifyPeriod(this.getgameid, data)
        if (res.status != '1') return this.$Message.error('修改失败')
        this.$Message.success('已修改');
        this.$emit("update:modal", false);
        this.$emit("resetList")
      } catch (error) {
        console.error(error);
        this.$Message.error('请填写正确资料')
      } finally {
        this.loading = false
      }
    }
  }
};
</script>